export default "__VITE_ASSET__DF6qk6Wr__"